import { CastAudioIcon } from './CastAudioIcon';

/**
 * author: Kinetic Screen
 * id E464AD1F-6036-43F9-9D9F-22390B2CBECB
 * name cast-audio
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cast-audio.svg
 * tags
 * - Audio 
 */
export const CastSpeakerIcon = CastAudioIcon;
export default CastSpeakerIcon